import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule, MatAutocompleteModule, MatCheckboxModule, MatButtonModule, MatFormFieldModule, MatTabsModule, MatSelectModule, MatDatepickerModule, MatIconModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportService } from './services/report/report.service';
import { StateSummaryComponent } from './components/state-summary/state-summary.component';
import { DepartmentSummaryComponent } from './components/department-summary/department-summary.component';
import { AgingPerEmployeeComponent } from './components/aging-per-employee/aging-per-employee.component';
import { AgingPerDeparmentComponent } from './components/aging-per-deparment/aging-per-deparment.component';
import { EmployeeTransactionComponent } from './components/employee-transaction/employee-transaction.component';

@NgModule({
  declarations: [
    StateSummaryComponent,
    DepartmentSummaryComponent,
    AgingPerEmployeeComponent,
    AgingPerDeparmentComponent,
    EmployeeTransactionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  exports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule
  ],
  providers:[    
    ReportService
  ],
  entryComponents:[
  ]
})
export class ReportModule { }
